import { Classes, NonIdealState, Spinner } from "@blueprintjs/core";
import React from "react";

import { ReadOnlyPlayComponent } from "../../../../components";
import { useGetSinglePlay } from "../../../../redux/slices";
import styles from "./play-display.module.scss";

interface PlayDisplayProps {
  playId: string;
}

export const PlayDisplay = ({ playId }: PlayDisplayProps) => {
  const { data: play, error } = useGetSinglePlay(playId);

  if (error) return <ErrorPlayDisplay />;
  if (!play) return <LoadingPlayDisplay />;

  const firstFrame = play.frames[0];

  if (!firstFrame) return <div>no frames</div>;

  return (
    <div className={styles.playDisplayContainer}>
      <div className={styles.playName}>{play.name}</div>
      <ReadOnlyPlayComponent play={play} playOnHover={true} interactive />
    </div>
  );
};

const LoadingPlayDisplay = () => {
  return (
    <div className={styles.playDisplayContainer} style={{ height: "300px" }}>
      <div className={styles.playName}>
        <span className={Classes.SKELETON}>playname here</span>
      </div>
      <Spinner size={100} style={{ flex: 1 }} />
    </div>
  );
};

const ErrorPlayDisplay = () => {
  return (
    <div className={styles.playDisplayContainer} style={{ height: "300px" }}>
      <NonIdealState title="Error" description="There was an error loading this play" icon="error" />
    </div>
  );
};
